import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';

import {
  FormConfig,
  FormField,
  IFormComponent,
  IFormConfig,
  IFormField,
} from '@models/form/form';

import {
  DateRangeField,
  IDateRangeField,
} from '@app/infrastructure/models/form/daterange';
import { ActivatedRoute } from '@angular/router';
import { ROUTES } from '@app/infrastructure/utils/constants';

@Component({
  selector: 'app-form-date-range-picker',
  templateUrl: './form-date-range-picker.component.html',
  styleUrls: [
    '../../dynamic-form.component.scss',
    './form-date-range-picker.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDateRangePickerComponent
  implements OnInit, IFormComponent<IDateRangeField>
{
  public config: IFormField<IDateRangeField> = new FormField<IDateRangeField>({
    fieldConfig: new DateRangeField(),
  });
  public formConfig: IFormConfig = new FormConfig();
  public group: UntypedFormGroup = new UntypedFormGroup({});

  public get formControl(): AbstractControl {
    return this.group.get(this.config.name);
  }

  public fromDate: Date;
  public toDate: Date;

  constructor(private router: ActivatedRoute) {}
  // These hidden controls will resolve to a single value
  ngOnInit() {
    this.group.addControl('fromDate', new UntypedFormControl(''));
    this.group.addControl('toDate', new UntypedFormControl(''));
    if (
      this.router.snapshot.data.title === ROUTES.teacher.editGradingPeriod.title
    ) {
      this.formatDateRange();
      this.group.patchValue({
        fromDate: this.fromDate,
        toDate: this.toDate,
      });
    }
  }

  public formatDateRange() {
    this.fromDate = new Date(this.router.snapshot.data.gradingPeriod.fromDate);
    this.toDate = new Date(this.router.snapshot.data.gradingPeriod.toDate);
  }

  public onStartChange(event: any): void {
    // Do something when start date changes...
  }

  public onEndChange(event: any): void {
    const start = new Date(this.group.get('fromDate').value);
    const end = new Date(this.group.get('toDate').value);

    // Set the value of the shadow control
    this.group
      .get(this.config.name)
      .setValue(`${start.toLocaleDateString()}-${end.toLocaleDateString()}`);
  }
}
